import { Troubleshooting } from './../models/troubleshooting';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-admin-visits',
  templateUrl: './admin-visits.component.html',
  styleUrls: ['./admin-visits.component.scss']
})
export class AdminVisitsComponent implements OnInit {

  requestType : string = "visit";
  title : string = "الزيارات";
  isVisitReviewed : boolean = true;
  constructor() { }

  ngOnInit() {
  }

}
